import { render, staticRenderFns } from "./StepWater.vue?vue&type=template&id=8309d25e&lang=html&"
import script from "./StepWater.vue?vue&type=script&lang=js&"
export * from "./StepWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports